import clamp from "./clamp.js";
export default function lerp(value, fromMin, fromMax, toMin, toMax) {
    const output = ((value - fromMin) / (fromMax - fromMin)) * (toMax - toMin) + toMin;
    return clamp(output, toMin, toMax);
}
//# sourceMappingURL=lerp.js.map